import React from 'react';
import { Row, Col } from 'react-bootstrap';
import "../articleDetailsWrapper/articleDetails.scss";
import { handleEmailClick, handleLinkedInShare } from '../../../../common/utils';
import { useAppContext } from '../../../../common/context';
import { integrationConfig } from '../../../../common/utils/config';

function ShareSection({ data }) {
  const {environment} = useAppContext();
  const {mediaShareURL} = integrationConfig[environment];
  
  const mailSubject= 'Check out this article from Best Buy Ads'
  const category = data.category
  const ctaurl = data.slug
  const URL = `${mediaShareURL}${category}${ctaurl}`
  const mailBody=`${data.title}   ${URL}`
  
  
  return (
    <div className='share-container'>
      <Row className='py-2'>
        <Col>
          <hr />
        </Col>
      </Row>

      <Row className="align-items-center pt-1">
        <Col xs="6" className="justify-content-start">
          <div className='d-flex share-link' >
            <div>Share</div>
          </div>
        </Col>

        <Col xs="6" className="d-flex justify-content-end">
          <i className="icon-size-sty bi bi-linkedin" 
          style={{cursor:'pointer'}}
          onClick={() => handleLinkedInShare(URL)}></i>
          <i 
          className="icon-size-sty bi bi-envelope" 
          onClick={() => handleEmailClick('info.ads@bestbuy.com',mailSubject,mailBody)}
          style={{cursor:'pointer'}}
          ></i>
        </Col>
      </Row>
    </div>
  )
}

export default ShareSection